import { Base, CreateObject, PostBase } from './metadata';

export interface CongressMilestones {
  event: {
    startDate: string | null;
    startDateConfirmed: boolean;
    endDate: string | null;
    endDateConfirmed: boolean;
    city: string | null;
    country: string | null;
  };
  abstractDue: {
    date: string | null;
    confirmed: boolean;
    callForAbstractUrl: string | null;
  };
  lateBreaking: {
    date: string | null;
    confirmed: boolean;
  };
}

export class Congress extends CreateObject {
  id!: number;
  congressName!: string;
  formalName!: string | null;
  acronym!: string | null;
  frequency!: string | null;
  numOfAttendees!: number | null;
  milestones!: CongressMilestones;
  website!: string | null;
  therapeuticAreas!: string | null;
  isVisible!: boolean;

  get displayName(): string {
    return this.acronym || this.congressName;
  }

  get abstractID(): string {
    return String(this.id);
  }

  get abstractDate(): string {
    return this.milestones?.event?.startDate?.split('T')[0] ?? '';
  }

  toPost(_changes: Base): PostBase {
    throw new Error('Congress does not support editing via POST');
  }
}

export interface CongressEndpointResponse {
  isOld: boolean;
  lastUpdate: string;
  congresses: Array<Congress>;
}
